import React, { Component } from 'react';
// import {faCheckCircle, faExclamationTriangle, faTimesCircle} from "@fortawesome/free-solid-svg-icons/index";
// import { Tooltip } from 'antd';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getLocalHour, isMainHour } from "../utils/CommonUtil";
import { okColor, warnColor, errorColor, nodataColor } from "../config";
import { StatusGoodSmall } from 'grommet-icons';
class StatusIcon extends Component {

  render() {
    const { status, time, hadBadSample } = this.props;
    // let rectangleStyle={
    //     height:'30px',
    //     width:'30px',
    //     margin:'auto',
    //     textAlign:'center',
    //     padding:'0px'
    // };

    // let dotStyle={
    //     height:'6px',
    //     width:'6px',
    //     backgroundColor: '#1aac60',
    //     borderRadius: '50%',
    //     margin:'12px 12px 12px 12px'
    // };
    // const rectangle=(<div style={rectangleStyle}>
    //     <Tooltip title="Normal">
    //         <FontAwesomeIcon size='2x' icon={faCheckCircle} color='#1aac60' style={{margin:'auto',padding:'0px'}} />
    //     </Tooltip></div>);
    // const dot=(<div style={rectangleStyle}><Tooltip title="Normal"><div style={dotStyle} /></Tooltip></div>);
    // const warnRectangle=(<div style={rectangleStyle}>
    //     <Tooltip title="Warning">
    //         <FontAwesomeIcon size='2x' icon={faExclamationTriangle} color='#ffc002' style={{margin:'0px',padding:'0px'}}/>
    //     </Tooltip></div>);
    // const errorRectangle=(<div style={rectangleStyle}>
    //     <Tooltip title="Error">
    //         <FontAwesomeIcon size='2x' icon={faTimesCircle} color='#e5004c' style={{margin:'0px',padding:'0px'}}/>
    //     </Tooltip> </div>);

    const localtime = getLocalHour(time);

    const pointStyle = {
      height: "41px"
    }

    const bigok = (<StatusGoodSmall color={okColor} size="15px" style={pointStyle} />);
    const bigwarn = (<StatusGoodSmall color={warnColor} size="15px" style={pointStyle} />);
    const bigerror = (<StatusGoodSmall color={errorColor} size="15px" style={pointStyle} />);
    const bignodata = (<StatusGoodSmall color={nodataColor} size="15px" style={pointStyle} />);

    const smallok = (<StatusGoodSmall color={okColor} size="9px" style={pointStyle} />);
    // const smallwarn = (<StatusGoodSmall color={warnColor} size="9px" style={pointStyle} />);
    // const smallerror = (<StatusGoodSmall color={errorColor} size="9px" style={pointStyle} />);
    const smallnodata = (<StatusGoodSmall color={nodataColor} size="9px" style={pointStyle} />);

    let icon;
    switch (status) {
      case 'green':
        if (isMainHour(localtime)) {
          icon = bigok;
        } else {
          icon = smallok;
        }
        break;
      case 'red':
        icon = bigerror;
        break;
      case 'error':
        icon = bigerror;
        break;
      case 'nodata':
        if (isMainHour(localtime)) {
          icon = bignodata;
        } else {
          icon = smallnodata;
        }
        break;
      case 'yellow':
        if (isMainHour(localtime)) {
          icon = bigwarn;
        } else {
          icon = bigwarn;
        }
        break;
      default:
        icon = bignodata;
        break;
    }

    if (status === 'green' && hadBadSample) {
      const isMain = isMainHour(localtime);
      return (
        <span
          title="An interruption or outage occurred during this hour"
          aria-label="Green status; an interruption or outage occurred during this hour"
          role="img"
          style={{
            display: 'inline-flex',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            width: isMain ? '15px' : '9px',
            height: '41px',
          }}
        >
          {icon}
          <span aria-hidden="true" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isMain ? '22px' : '16px',
            height: isMain ? '22px' : '16px',
            border: '2px solid #c47d00',
            borderRadius: '50%',
            boxSizing: 'border-box',
            pointerEvents: 'none',
          }} />
        </span>
      );
    }
    return icon;
  }
}

export default StatusIcon;
